var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React from 'react';
import styled from 'styled-components';
var StyledDrawer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: ", ";\n  box-shadow: ", ";\n  height: calc(100% - ", ");\n  ", ": 0;\n  overflow-x: hidden;\n  overflow-y: auto;\n  padding: 1em 0;\n  position: absolute;\n  top: ", ";\n  width: 0;\n  transition: width 200ms ease-in-out, padding 200ms ease-in-out;\n\n  &.open {\n    position: fixed;\n\n    @media (max-width: 576px) {\n      width: 100%;\n    }\n    @media (min-width: 577px) {\n      padding: 1em 1.5em;\n      ", ";\n    }\n  }\n"], ["\n  background-color: ", ";\n  box-shadow: ", ";\n  height: calc(100% - ", ");\n  ", ": 0;\n  overflow-x: hidden;\n  overflow-y: auto;\n  padding: 1em 0;\n  position: absolute;\n  top: ", ";\n  width: 0;\n  transition: width 200ms ease-in-out, padding 200ms ease-in-out;\n\n  &.open {\n    position: fixed;\n\n    @media (max-width: 576px) {\n      width: 100%;\n    }\n    @media (min-width: 577px) {\n      padding: 1em 1.5em;\n      ", ";\n    }\n  }\n"])), function (p) {
  return p.theme.level0;
}, function (p) {
  return p.theme.boxShadow;
}, function (p) {
  return p.theme.topBarHeight;
}, function (p) {
  return p.align === 'left' ? 'left' : 'right';
}, function (p) {
  return p.theme.topBarHeight;
}, function (p) {
  return p.theme.sidebarWidthAdjust('width', p);
});

var Drawer = function Drawer(_a) {
  var _b = _a.align,
      align = _b === void 0 ? 'right' : _b,
      children = _a.children,
      isOpen = _a.isOpen,
      props = __rest(_a, ["align", "children", "isOpen"]);

  return React.createElement(StyledDrawer, Object.assign({
    className: "drawer" + (isOpen ? ' open' : ''),
    align: align
  }, props), children);
};

export default Drawer;
var templateObject_1;